import { render, staticRenderFns } from "./take-palm-two.vue?vue&type=template&id=e8eef574&scoped=true"
import script from "./take-palm-two.vue?vue&type=script&lang=ts"
export * from "./take-palm-two.vue?vue&type=script&lang=ts"
import style0 from "./take-palm-two.vue?vue&type=style&index=0&id=e8eef574&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8eef574",
  null
  
)

export default component.exports